module.exports = __webpack_public_path__ + "94a22bcef2e0aa20e394e5a9b2d07416.svg";